
import makerjs from "makerjs";
function C07(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       w = W * 1 * myZoom,       
       h = H * 1 * myZoom,
     
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0=0,y0=0,x1=w/2,y1=h,x2=w,y2=0,glassH = h, glassW = w;

   if (w !== 0) {
       var TxtW = W;
   }if (h !== 0) {
    var TxtH = H;
} 
   var drawAbnormalShapeC07 = {
       paths: {
        "ArcLine": new makerjs.paths.Arc([x0,y0], [x1,y1],[x2,y2]),
        "BottomLine": new makerjs.paths.Line([x0,y0], [x2,y2]),
       }
   };
   var drawAbnormalShapeC07MarkW = {
       paths: {
        "Line": new makerjs.paths.Line([x0,y0-markShift], [x2,y2-markShift]),
        "LeftLine": new makerjs.paths.Line([x0,y0-2*markShift], [x0,y0]),
        "RithgLine": new makerjs.paths.Line([x2,y2-2*markShift], [x2,y2]),
       }
   };
   var drawAbnormalShapeC07MarkH = {
       paths: {
        "Line": new makerjs.paths.Line([w/2, 0], [w/2, h]),
        // "LineUp": new makerjs.paths.Line([0-markShift, h], [0+markShift, h]),
        // "LineDn": new makerjs.paths.Line([0-markShift, 0], [0+markShift, 0]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC07MarkW, TxtW, [x0,y0-2*markShift], [x2,y2-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC07MarkH, TxtH, [w/2-markShift, 0], [w/2-markShift, h]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC07: drawAbnormalShapeC07,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC07: drawAbnormalShapeC07,
        drawAbnormalShapeC07MarkW: drawAbnormalShapeC07MarkW,
        drawAbnormalShapeC07MarkH: drawAbnormalShapeC07MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C07;